import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

// Tokens MUST load before App so the first paint already has the
// design system applied — otherwise the smoke surface flashes the
// browser default white background before the theme kicks in.
import './theme/tokens.css';
// i18next must initialise before any component calls useTranslation,
// or the first render falls back to the raw key strings.
import './i18n';
import { App } from './App';

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element #root missing from index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
